import { render, staticRenderFns } from "./TableCellMenu.vue?vue&type=template&id=2d0c1664"
import script from "./TableCellMenu.vue?vue&type=script&lang=js"
export * from "./TableCellMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports